<template lang="html">
  <span v-if="active" :class="'notification-sign' + (right ? ' right-icon' : ' left-icon')">
  </span>
</template>

<script>
export default {
  props: {
    active: Boolean,
    right: Boolean
  }
}
</script>

<style lang="scss">
  .notification-sign {
    position: absolute;
    background-color: #FF1818;
    border-radius: 46%;
    width: 0.60rem;
    height: 0.60rem;
    color: white;
    font-weight: bold;
    line-height: 180%;

    &.right-icon {
      right: 4px;
    }

    &.left-icon {
      top: 0;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/NotificationSign.vue